import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import FormButton from "components/buttons/FormButton";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";

const toSlug = (value) =>
    (value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^A-Z0-9-]/g, "")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

const FormTruck = ({item, setItem, setShowCanvas, showCanvas, fetchTrucks}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef({plate: null});

    const handleClose = () => setShowCanvas(false);

    const handleChange = (e) => {
        const {name, type} = e.target;
        const value = type === "checkbox" ? e.target.checked : e.target.value;
        let item_ = {...item};
        item_[name] = name === "plate" ? toSlug(value) : value;
        setItem(item_);
    };

    const handleSubmit = () => {
        if (!item || !item.plate) {
            Alert.warning("Falta dato obligatorio", "Es necesaria una Matrícula").then(() => {
                inputRefs.current.plate && inputRefs.current.plate.focus();
            });
            return;
        }
        setIsLoading(true);

        const payload = {
            id: item.id || null,
            plate: item.plate,
            identifier: item.identifier || "",
            brand: item.brand || "",
            model: item.model || "",
            capacity_kg: item.capacity_kg || null,
            volume: item.volume || null,
            autonomy: item.autonomy || null,
            download_type: item.download_type || "",
            active: item.active,
        };

        axiApi
            .post("/api/fleet/truck/", payload)
            .then((resp) => {
                if (resp.data) {
                    fetchTrucks();
                    setShowCanvas(false);
                    Alert.info("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.error("Error al guardar", resp.data?.message || "Consultar con el administrador");
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.error("Error servidor", "Consultar con el administrador");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Offcanvas
            show={showCanvas}
            onHide={handleClose}
            placement="end"
            backdrop="static"
            style={{width: "40%", fontSize: "15px"}}>
            <Offcanvas.Header className="preview-canvas">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="truck" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>{_Tr("labels.trucks")}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                <div className="container-fluid">
                    <div className="row g-3 mb-5 pb-5">
                        <div className="col-12">

                            {/* Matrícula */}
                            <div className="row g-3 align-items-center">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.plate")} *</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="plate"
                                        value={item.plate || ""}
                                        onChange={handleChange}
                                        ref={(el) => (inputRefs.current.plate = el)}
                                    />
                                </div>
                            </div>

                            {/* Identificador */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.identifier")}</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="identifier"
                                        value={item.identifier || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Marca */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.brand")}</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="brand"
                                        value={item.brand || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Modelo */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.model")}</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="model"
                                        value={item.model || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Capacidad */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.capacity")}</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="capacity_kg"
                                        step="any"
                                        min="0"
                                        value={item.capacity_kg || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Volumen */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.volume")}</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="volume"
                                        step="any"
                                        min="0"
                                        value={item.volume || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Autonomía */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.autonomy")}</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="autonomy"
                                        step="any"
                                        min="0"
                                        value={item.autonomy || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Tipo de carga */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.download_type")}</label>
                                </div>
                                <div className="col-9">
                                    <DownloadTypesSelect
                                        value={item.download_type || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Activo */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("truck.active")}</label>
                                </div>
                                <div className="col-9">
                                    <Form.Check
                                        type="switch"
                                        name="active"
                                        checked={!!item.active}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="p-3 buttons-footer">
                    <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {_Tf("labels.cancel")}
                        </button>
                        <FormButton
                            label="Guardar"
                            className="btn btn-primary ms-4"
                            isProcessing={isLoading}
                            onClick={handleSubmit}>
                            {_Tf("labels.save")}
                        </FormButton>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormTruck;
